export function FooterCareer() {
    return (
        <div className="footerCareer">
            <div className="footer-text">
                <span className="label">Powered by</span><span className="brand"> Team 4</span>
            </div>
        </div>
    )
}